<template>
    <div v-if="loading_titulo === true">
      <loading />
    </div>
    <div v-else>
      <div class="col s12 m12 no-padding doc-type-section">
        <div class="input-field col s12 m6">
          <input v-model="titulo.pf_tit_ele" id="tit_numero" type="text" class="validate">
          <label for="tit_numero">Número</label>
        </div>
        <div class="input-field col s12 m3">
          <input v-model="titulo.pf_tit_ele_zon" id="tit_zona" type="text" class="validate">
          <label for="tit_zona">Zona</label>
        </div>
        <div class="input-field col s12 m3">
          <input v-model="titulo.pf_tit_ele_sec" id="tit_secao" type="text" class="validate">
          <label for="tit_secao">Seção</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="titulo.pf_tit_ele_emissao"  v-mask="['##/##/####']" id="tit_dt_emissao" type="text" class="validate">
          <label for="tit_dt_emissao">Data de Emissão</label>
        </div>
        <!-- 
        <div class="input-field col s12 m6">
          <input v-model="titulo.tit_localidade" type="text" id="tit_localidade" class="autocomplete" autocomplete="none">
          <label for="tit_localidade">Localidade</label>
        </div> 
        -->
      </div>
      <div class="input-field col s12 m12">
        <button @click="prepareSubmitTitulo" v-bind:disabled="verificaForm === false" class="btn right" type="button">SALVAR</button>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import {converteData, formataData} from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import { verificaData } from '@/assets/js/form-utils'
import sha1 from 'js-sha1'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'TituloEleitor',
  components: {
    'loading': Loading,
  },
  props: {
      doc: Object,
      pf_id: String
  },
  data (){
    return {
      loading_titulo: false,
      meta: this.$store.state.meta.data,
      titulo: {
        pf_tit_ele: this.doc.titulo_eleitor,
        pf_tit_ele_sec: this.doc.secao,
        pf_tit_ele_zon: this.doc.zona,
        pf_tit_ele_emissao: (verificaData(this.doc.emissao, 'YYYY-MM-DD') === true ? converteData(this.doc.emissao) : null),
        cidade_id: this.doc.localidade,
      },
      error_fields: {},
      loaded: null,      
    }
  },
  computed: {
    verificaForm: function() {
        let status = (
            Object.keys(this.titulo).filter((k) => this.titulo[k] && this.titulo[k] != '').length === 5
            && 
            (verificaData(this.titulo.pf_tit_ele_emissao) === true)
        )
        this.$emit('statusChange', {
          doc: 4,
          status: status
        })
        return status
    }
  },
  methods: {
    async submitInsertTitulo(titulo){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/titulo-eleitor/`, {
        ...titulo,
        ...{
          'pf_id': this.pf_id,
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.loading_titulo = false
        setTimeout(() => {
          this.initFields()
          this.$emit('docSaved', 3)
        }, 100)
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_titulo = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    prepareSubmitTitulo(){
      this.loading_titulo = true
      let a = this.titulo //Atual

      let titulo = {
        pf_id: this.pf_id,
        pf_tit_ele: this.titulo.pf_tit_ele,
        pf_tit_ele_sec: this.titulo.pf_tit_ele_sec,
        pf_tit_ele_zon: this.titulo.pf_tit_ele_zon,
        pf_tit_ele_emissao: (verificaData(this.titulo.pf_tit_ele_emissao, 'YYYY-MM-DD') === true ? formataData(this.titulo.pf_tit_ele_emissao) : null),
        cidade_id: this.titulo.cidade_id
      }

      if(this.loaded !== sha1(JSON.stringify(titulo))){
        return this.submitInsertTitulo(titulo)
      } else {
        this.loading_titulo = false
        this.$emit('docSaved', 3)
      }
    },
    initFields () {
      M.updateTextFields()
      M.FormSelect.init(document.querySelectorAll('select'))
    },
    verificaStatusDocumento(){
      return true //Não obrigatório
    }
  },
  mounted(){
    this.loaded = sha1(JSON.stringify({
      pf_id: this.pf_id,
      pf_tit_ele: this.titulo.pf_tit_ele,
      pf_tit_ele_sec: this.titulo.pf_tit_ele_sec,
      pf_tit_ele_zon: this.titulo.pf_tit_ele_zon,
      pf_tit_ele_emissao: (verificaData(this.titulo.pf_tit_ele_emissao, 'YYYY-MM-DD') === true ? formataData(this.titulo.pf_tit_ele_emissao) : null),
      cidade_id: this.titulo.cidade_id
    }))

    this.initFields()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/documentos/TituloEleitor.vue